/* Velara a11y helpers — focus trap for drawers/modals. Shared. */
window.VelaraA11y = (function () {
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let active = null;
  let lastFocused = null;

  function onKey(e) {
    if (e.key !== 'Tab' || !active) return;
    const items = active.querySelectorAll(FOCUSABLE);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  return {
    trap(panel) {
      lastFocused = document.activeElement;
      active = panel;
      const first = panel.querySelector(FOCUSABLE);
      if (first) setTimeout(() => first.focus(), 50);
      document.addEventListener('keydown', onKey);
    },
    release() {
      document.removeEventListener('keydown', onKey);
      active = null;
      if (lastFocused && lastFocused.focus) lastFocused.focus();
      lastFocused = null;
    }
  };
})();
